import { useState } from 'react';

import { useGetArrangements, useGetTravelCompensationType } from 'queries';
import { useTranslation } from 'react-i18next';

import TableCRUDLayout from 'components/shared/CRUD/TableCRUDLayout';

import WithInnerLayout, {
  WithInnerLayoutProps
} from '../../../../shared/CRUD/components/InnerPage/WithInnerLayout';
import useNavigateAfterCreate from '../../../../shared/CRUD/components/InnerPage/hooks/useNavigateAfterCreate';
import { CreateArrangementDrawer } from './components/CreateArrangementDrawer';
import EditArrangement from './components/innerView/EditArrangement';

import { useColumnDefinitions } from './arrangementsUtils';
import { useDeleteArrangements } from './hooks/useDeleteArrangements';
import { useSelector } from 'hooks';

const Arrangements: React.FC<WithInnerLayoutProps> = ({
  isInnerLayoutOpen,
  setIsInnerLayoutOpen
}) => {
  const { t } = useTranslation('common');
  const { hasTravelMovementsFeature } = useSelector(({ grants }) => grants);
  const columns = useColumnDefinitions({ hasTravelMovementsFeature });

  const { data: arrangementTypes, isFetching: isArrangementTypesFetching } =
    useGetTravelCompensationType();

  const [rowData, setRowData] = useState(undefined);

  const {
    data: arrangements,
    isFetching,
    refetch,
    isError
  } = useGetArrangements(arrangementTypes ?? [], {
    enabled: !isArrangementTypesFetching
  });

  const onViewCLick = (rowData) => {
    setRowData(rowData);
    setIsInnerLayoutOpen(true);
  };

  useNavigateAfterCreate(arrangements, onViewCLick);

  const deleteArrangement = useDeleteArrangements();

  const toggleInnerLayout = () => {
    setIsInnerLayoutOpen(!isInnerLayoutOpen);
  };

  if (isInnerLayoutOpen && rowData) {
    return (
      <EditArrangement
        rowData={rowData}
        setIsInnerLayoutOpen={setIsInnerLayoutOpen}
        toggleInnerLayout={toggleInnerLayout}
        refreshList={refetch}
        rows={arrangements}
      />
    );
  }

  return (
    <>
      <TableCRUDLayout
        columns={columns}
        rows={arrangements}
        loading={isFetching}
        FormComponent={CreateArrangementDrawer}
        getRowId={(arrangement) => arrangement.trvSetId}
        editable={false}
        onDeleteClick={(id) => deleteArrangement(id)}
        confirmationTitle={t(
          'adminPortal.arrangements.deleteArrangementDialog.title'
        )}
        confirmationBody={t(
          'adminPortal.arrangements.deleteArrangementDialog.body'
        )}
        hasLoadingError={isError}
        onLoadingError={refetch}
        onViewClick={(rowId, rowData) => onViewCLick(rowData)}
      />
    </>
  );
};

export default WithInnerLayout(Arrangements);
